// 1. எல்லாத்துக்கும் மேல இந்த "Polyfill" கோடைச் சேர்க்கவும்
if (typeof window !== 'undefined') {
  if (!window.speechSynthesis) {
    window.speechSynthesis = {
      speak: () => {},
      cancel: () => {},
      pause: () => {},
      resume: () => {},
      getVoices: () => [],
      onvoiceschanged: null,
      pending: false,
      speaking: false,
      paused: false
    };
  }
  if (!window.SpeechSynthesisUtterance) {
    window.SpeechSynthesisUtterance = function() {
      return {
        lang: '',
        pitch: 1,
        rate: 1,
        text: '',
        volume: 1,
        onstart: null,
        onend: null,
        onerror: null
      };
    };
  }

  // --- 2. FIRST RUN STORAGE CLEAR LOGIC ---
  const APP_FIRST_RUN_KEY = 'shep_app_first_run_cleared';
  
  // இந்த கீ இல்லையென்றால், இதுதான் முதல் முறை (அல்லது Re-install)
  if (!localStorage.getItem(APP_FIRST_RUN_KEY)) {
    // முழுமையாக அனைத்தையும் Clear செய்கிறோம்
    localStorage.clear();
    sessionStorage.clear();
    
    // Clear செய்த பிறகு, மீண்டும் Clear ஆகாமல் இருக்க Flag-ஐ செட் செய்கிறோம்
    localStorage.setItem(APP_FIRST_RUN_KEY, 'true');
    console.log('App First Run / Fresh Install: Storage Cleared Successfully.');
  }
  // ----------------------------------------
}

// 3. உங்களின் பழைய Imports
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './store/store'; 
import App from './App';
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './meeting-responsive.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
